import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(({ breakpoints, palette, spacing }) => ({
  instructions: {
    gridArea: "Instructions",
    position: "relative",
    display: "flex",
    alignItems: "center",
  },

  content: {
    margin: `${spacing(5)}px ${spacing(15)}px`,
    display: "grid",
    gridTemplateRows: "20vh 30vh",
    alignItems: "center",
    [breakpoints.up("lg")]: {
      gridTemplateRows: "10vh 20vh",
    },
  },
  contentMob: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    paddingTop: "20px",
    paddingBottom: "20px",
  },
  work: {
    display: "grid",
    gridTemplateColumns: "30% auto 30% auto 30%",
    gap: spacing(2),
    alignItems: "start",
  },

  workMob: {
    marginTop: "20px",
    width: "90%",
    marginLeft: "20px",
  },
  text: {
    display: "flex",
    flexDirection: "column",
  },
  title: {
    color: "#1A3154",
    fontWeight: 800,
    fontSize: "52px",
    lineHeight: "63px",
    textTransform: "uppercase",
  },
  titleMob: {
    color: "#1A3154",
    fontWeight: 800,
    fontSize: "60px",
    lineHeight: "63px",
    textTransform: "uppercase",
    marginLeft: "15px",
  },
  subtitle: {
    margin: `0 0 ${spacing(2)}px 0`,
    fontWeight: 800,
    fontSize: "24px",
    lineHeight: "29px",
  },
  subtitleMob: {
    margin: `0 0 ${spacing(2)}px 0`,
    fontWeight: 800,
    fontSize: "34px",
    lineHeight: "29px",
  },
  paragraph: {
    color: "#5E6162",
    fontWeight: 600,
    fontSize: "18px",
    lineHeight: "22px",
  },
  paragraphMob: {
    color: "#5E6162",
    fontWeight: 600,
    fontSize: "26px",
  },
  icon: {
    color: palette.secondary.main,
    fontSize: "4em",
  },
}));

export default useStyles;
